<script setup lang="ts">
import type { StepStepType } from 'src/types/course/step';
import type { UserStep } from '../../models/UserStep';
import { stepTypeFromStepType } from '../../useStepData';
import StepListItem from '../StepListItem/StepListItem.vue';

type Props = {
  userSteps: UserStep[];
};

defineProps<Props>();

defineEmits<{
  slectedUserStep: [UserStep];
}>();

const stepType = (userStep: UserStep) => {
  const s_type = stepTypeFromStepType(
    userStep?.step?.step_type as StepStepType[],
  );
  return s_type;
};
</script>

<template>
  <q-list
    separator
    :bordered="userSteps.length === 1"
  >
    <StepListItem
      v-for="userStep in userSteps"
      :key="userStep.id"
      :step-name="userStep?.step?.step_name"
      :step-type="stepType(userStep) ?? undefined"
      :step-category="userStep?.step?.step_category"
      :step-score="userStep?.score ?? 0"
      :start-date="userStep?.start_date"
      :completion-date="userStep?.completion_date"
      @click="$emit('slectedUserStep', userStep)"
    />
  </q-list>
</template>
